// 引入二次封装
import request from "@/utils/request.js";

// // 导出get请求的接口方法
// export function myget(params) {
//   return request({
//     url: "xxx",
//     method: "get",
//     params,
//   });
// }

// // 导出post请求的接口方法
// export function mypost(data) {
//   return request({
//     url: "xxx",
//     method: "post",
//     data,
//   });
// }



// 未读消息
export function unreadMessage(params) {
  return request({
    url: "/api/message/unread_message",
    method: "get",
    params,
  });
}




// 获取站内信息列表
export function onMessageList(data) {
  return request({
    url: "/api/message/index",
    method: "post",
    data,
    // headers:{ token }
  });
}

// 获取站内信息详情
export function messageInfo(data) {
  return request({
    url: "/api/message/info",
    method: "post",
    data,
    // headers:{ token }
  });
}


// 已读
export function haveRead(data) {
  return request({
    url: "/api/message/read_message",
    method: "post",
    data,
  });
}

// 删除
export function haveDelete(data) {
  return request({
    url: "/api/message/del_message",
    method: "post",
    data,
  });
}
